<template>
  <div class="resultPageSPBU">
    <div class="resultPageSPBU__loading" v-if="isPageLoading">
      <adx-loading-primary/>
    </div>
    <div v-if="!isPageLoading">
      <div class="resultPageSPBU__top">
        <div class="resultPageSPBU__top__header">
            <h1 class="resultPageSPBU__top__header__title large-title" v-if="this.$route.params.city_name">
            SPBU in {{title | sentencecase}}
            </h1>
            <h1 class="resultPageSPBU__top__header__title large-title" v-else>
            SPBU
            </h1>
        </div>
        <div class="resultPageSPBU__top__filter">
            <div class="resultPageSPBU__top__filter__left">
            <template>
                <adx-dropdown-checkbox @selected="selectedLocation"
                :list="locationOptions"
                :color="'pink'"
                labelButton="Location"
                :title="`Location`" :default="selectedLocationValue" />
                <adx-dropdown-checkbox @selected="selectedSocial"
                :list="socialOptions"
                :color="'pink'"
                labelButton="Social"
                :title="`Social`" :default="selectedSocialValue" />
                <adx-dropdown-checkbox @selected="selectedProfile"
                :list="profileOptions"
                :color="'pink'"
                labelButton="Profile"
                :title="`Profile`" :default="selectedProfileValue" />
            </template>
            <div class="resultPageSPBU__top__filter__left__sort--mobile">
                <!-- <button class="btn-regular" :class="[labelType == 'Type' ? 'secondary' : 'pink']" @click="showQuickFilter = true">{{labelType | capitalizing}}</button> -->
                <adx-dropdown-list class="sort-mobile" @selected="selectedSort" :list="sortOptions" labelButton="Sort by" :title="`Sort by`" />
            </div>
            <div v-if="filtered" class="reset">
                <button class="btn-regular link" @click="resetFilter">Reset</button>
            </div>
            </div>
            <div class="resultPageSPBU__top__filter__right">
            <span class="subhead">Sort by :</span>
            <div>
                <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sortOptions" />
            </div>
            </div>
        </div>
      </div>
      <div class="resultPageSPBU__bottom">
        <div class="resultPageSPBU__bottom__content">
            <div class="resultPageSPBU__bottom__content__listings" v-if="!isSubLoading">
                <div class="resultPageSPBU__bottom__content__listings__collection">
                  <div class="resultPageSPBU__bottom__content__listings__collection__header">
                    <h2 class="small-title">Collection in SPBU</h2>
                    <button class="link desktop" @click.stop="allCollection()">See all <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
                  </div>
                  <adx-collection-slider :slide="5" :slideMobile="2" :data="collectionOptions"/>
                </div>
                <template>
                    <adx-list-result v-if="totalListing" :data='itemsCategory'
                    @createNew="createNew" @goToParentDetail="goToLocationDetail"
                    :custom="user.admin" @customAdvertisement="customAdvertisement"
                    @createNewCampaign="createNewCampaign" :isAction="true" :viewPhotos="false"
                    :menuList="expansionList"
                    @addToCampaign="addToCampaign">
                        <template slot="loading" v-if="!isSubLoading">
                        <template v-if="!isLoading">
                            <div v-if="next" class="resultPageSPBU__bottom__content__listings__paging" @click.stop="loadInfiniteData">
                                <button class="btn-regular secondary"> <strong>Load More</strong> </button>
                            </div>
                            <div v-else class="resultPageSPBU__bottom__content__listings__paging">
                                <span class="resultPageSPBU__bottom__content__listings__paging__empty"> There is no more data </span>
                            </div>
                        </template>
                        <template v-else>
                            <adx-loading-primary />
                        </template>
                        </template>
                    </adx-list-result>
                    <adx-empty-selection v-else-if="!isLoading"/>
                </template>
            </div>
            <div class="resultPageSPBU__bottom__content__loadingBottom" v-else>
            <adx-loading-primary />
            </div>
            <div class="resultPageSPBU__bottom__content__orderSummary" v-if="!isSubLoading">
                <div class="resultPageSPBU__bottom__content__orderSummary__header">
                    Order Summary
                </div>
                <div class="resultPageSPBU__bottom__content__orderSummary__content" v-if="selectedItems.length>0">
                  <div class="resultPageSPBU__bottom__content__orderSummary__content__period" v-if="isPackage">
                    <adx-dropdown-sort id="campaign-period" :label="`Period of Campaign`" :value.sync='selectedPeriod' :options="dropdownOptions"/>
                  </div>
                  <div class="resultPageSPBU__bottom__content__orderSummary__content__period">
                    <div class="calendar">
                      <v-date-picker
                        v-model='startDate'
                        :popoverVisibility="'focus'"
                        :min-date='nextweek'
                        :theme-styles='themeStyles'
                        class='date-picker'>
                        <div class="field"
                          slot-scope='{ inputValue, updateValue }'
                        >
                          <input
                            class="date-picker-input"
                            type='text'
                            required
                            readonly
                            :value='inputValue'
                            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                            <label id="date-label" class="subhead calendar-label">Start Date</label>
                        </div>
                      </v-date-picker>
                    </div>
                    <div class="calendar">
                      <v-date-picker
                        v-model='endDate'
                        :popoverVisibility="isPackage? 'hidden' : 'focus'"
                        :min-date='startDate > nextweek ? startDate : nextweek'
                        :theme-styles='themeStyles'
                        popover-align="left"
                        class='date-picker'>
                        <div class="field"
                          slot-scope='{ inputValue, updateValue }'
                        >
                          <input
                            class="date-picker-input"
                            :class="[isPackage ? 'disable-calendar' : '']"
                            placeholder="DD/MM/YY"
                            type='text'
                            required
                            readonly
                            :value='inputValue'
                            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                            <label id="date-label" class="subhead calendar-label">End Date</label>
                        </div>
                      </v-date-picker>
                    </div>
                  </div>
                  <div class="resultPageSPBU__bottom__content__orderSummary__content__items">
                  <div class="resultPageSPBU__bottom__content__orderSummary__content__items__item" v-for="(item, index) in selectedItems" :key="index">
                    <div class="resultPageSPBU__bottom__content__orderSummary__content__items__item__left">
                      <i class="icon-deleted" @click="deleteOrder(index)"></i>
                      <div class="resultPageSPBU__bottom__content__orderSummary__content__items__item__left__body">
                        <h6 class="small-font font-15__weightBold">{{item.title}}</h6>
                        <h6 class="small-font color-grey font-15">{{item.media_name}}</h6>
                      </div>
                    </div>
                    <div>
                      <span class="resultPageSPBU__bottom__content__orderSummary__content__items__item__right small-font color-pink font-15__weightBold"> 
                        {{item.price | formatMoney}}
                      </span>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="resultPageSPBU__bottom__content__orderSummary__content" v-else>
                  <span class="resultPageSPBU__bottom__content__orderSummary__content__empty"> 
                    Please select at least one advertisement to add an order 
                  </span>
                </div>
                <div class="resultPageSPBU__bottom__content__orderSummary__footer" v-if="selectedItems.length>0">
                <div class="resultPageSPBU__bottom__content__orderSummary__footer__ppn">
                  <h2 class="small-font font-15">PPN 10%</h2>
                  <h2 class="small-font price color-pink font-15">{{(0.1 * getTotal()) | formatMoney}}</h2>
                </div>
                <div class="resultPageSPBU__bottom__content__orderSummary__footer__total">
                  <h2 class="small-font font-15">Total Order</h2>
                  <h1 class="price large-font color-pink">{{getTotalByPPN() | formatMoney}}</h1>
                </div>
                </div>
                <div class="resultPageSPBU__bottom__content__orderSummary__footer">
                    <button class="btn-large primary continue" :disabled="selectedItems.length<1"> Continue </button>
                </div>
            </div>
        </div>
      </div>
      <div class="resultPageSPBU__modalMobile">
      <adx-modal v-if="isShowOrderMobile" :hide-close="true">
        <template slot="content">
          <div>
          <div class="resultPageSPBU__bottom__content__orderSummary--mobile" v-if="!isSubLoading">
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__close"><i class="icon-close" @click="toggleModalOrder"></i></div>
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__header font-24__weightBold">
                Order Summary
            </div>
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content" v-if="selectedItems.length>0">
              <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__period">
                <adx-dropdown-sort id="campaign-period" :label="`Period of Campaign`" :value.sync='selectedPeriod' :options="dropdownOptions"/>
              </div>
              <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__period">
                <div class="calendar">
                  <v-date-picker
                    v-model='startDate'
                    :popoverVisibility="'focus'"
                    :min-date='nextweek'
                    :theme-styles='themeStyles'
                    class='date-picker'>
                    <div class="field"
                      slot-scope='{ inputValue, updateValue }'
                    >
                      <input
                        class="date-picker-input"
                        type='text'
                        required
                        readonly
                        :value='inputValue'
                        @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                        @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                        <label id="date-label" class="subhead calendar-label">Start Date</label>
                    </div>
                  </v-date-picker>
                </div>
                <div class="calendar">
                  <v-date-picker
                    v-model='endDate'
                    :popoverVisibility="isPackage? 'hidden' : 'focus'"
                    :min-date='startDate > nextweek ? startDate : nextweek'
                    :theme-styles='themeStyles'
                    class='date-picker'>
                    <div class="field"
                      slot-scope='{ inputValue, updateValue }'
                    >
                      <input
                        class="date-picker-input"
                        :class="[isPackage ? 'disable-calendar' : '']"
                        type='text'
                        required
                        readonly
                        :value='inputValue'
                        @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                        @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                        <label id="date-label" class="subhead calendar-label">End Date</label>
                    </div>
                  </v-date-picker>
                </div>
              </div>
              <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__items">
                <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__items__item" v-for="(item, index) in selectedItems" :key="index">
                  <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__items__item__left">
                    <i class="icon-deleted" @click="deleteOrder(index)"></i>
                    <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content__items__item__left__body">
                      <h6 class="small-font font-15__weightBold">{{item.title}}</h6>
                      <h6 class="small-font color-grey font-15">{{item.media_name}}</h6>
                    </div>
                  </div>
                  <div>
                    <span class="resultPageSPBU__bottom__content__orderSummary--mobile__content__items__item__right small-font color-pink font-15__weightBold"> 
                      {{item.price | formatMoney}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__content" v-else>
              <span class="resultPageSPBU__bottom__content__orderSummary--mobile__content__empty"> 
                Please select at least one advertisement to add an order 
              </span>
            </div>
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__footer" v-if="selectedItems.length>0">
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__footer__ppn">
              <h2 class="small-font font-15">PPN 10%</h2>
              <h2 class="small-font price color-pink font-15">{{(0.1 * getTotal()) | formatMoney}}</h2>
            </div>
            <div class="resultPageSPBU__bottom__content__orderSummary--mobile__footer__total">
              <h2 class="small-font font-15">Total Order</h2>
              <h1 class="price large-font color-pink">{{getTotalByPPN() | formatMoney}}</h1>
            </div>
            </div>
          </div>
          <div class="resultPageSPBU__bottom__content__orderSummary--mobile__footerContinue">
            <button class="btn-large primary continue" :disabled="selectedItems.length<1" @click="continueButton"> Continue </button>
          </div>
          </div>
        </template>
      </adx-modal>
      </div>
      <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="toggleModalCreate" type='small' :noTitle="true">
        <div class="resultPageSPBU__modal" slot="content">
          <div class="resultPageSPBU__modal__input">
            <input ref="input" type="text" @keyup="KeyUp">
            <label class="subhead">Folder Name</label>
          </div>
          <div class="resultPageSPBU__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCreate">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createFolder">Save</button>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
        <div class="resultPageSPBU__modal" slot="content">
          <div class="resultPageSPBU__modal__input">
            <input ref="input" type="text" @keyup="KeyUpCampaign">
            <label class="subhead">Campaign Name</label>
          </div>
          <div class="resultPageSPBU__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createCampaign">Save</button>
          </div>
        </div>
      </adx-modal>
    </div>
    <adx-modal v-if="isShowCustomAds" :hide-close="true" @modal-close="toggleModalCustomAds">
      <div class="resultPageSPBU__modalAds" slot="content">
        <div class="resultPageSPBU__modalAds__close"><i class="icon-close" @click="toggleModalCustomAds"></i></div>
        <div class="resultPageSPBU__modalAds__header font-24__weightBold">
          Add Custom Advertisement
        </div>
        <div class="resultPageSPBU__modalAds__input">
          <adx-input :label="`Advertisement Name`" :value.sync="customNameInput" />
          <adx-textarea :label="`Comment`" :value.sync="customDescriptionInput" />
          <adx-input :label="`Price`" :value.sync="customPriceInput" />
        </div>
        <div class="resultPageSPBU__modalAds__buttons">
          <button class="btn-large secondary" @click="toggleModalCustomAds">Cancel</button>
          <button class="btn-large primary save" :disabled="isLoadingModal"
          @click="saveCustomAdv">Save<adx-loading-secondary v-if="isLoadingModal"/></button>
        </div>
      </div>
    </adx-modal>
    <div class="resultPageSPBU__orderFooter">
      <button class="btn-large primary continue" @click="toggleModalOrder"> 
        <span class="font-15__weightBold">
          View Order 
        </span>
        <span class="font-15" v-if="sumOrder>1">
          {{sumOrder}} Items
        </span>
        <span class="font-15" v-else>
          {{sumOrder}} Item
        </span>
        <span class="font-15">
          {{getTotalByPPN() | formatMoney}}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdownCustom'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import InfiniteLoading from 'vue-infinite-loading'
import ExpandableResult from '@/components/ExpandableListItems'
import Modal from '@/components/Modal'
import CollectionSlider from '@/components/Slider/CardSlider'
import Input from '@/components/Form/Input'
import Textarea from '@/components/Form/TextArea'
import EmptySelection from '@/components/NotFound/Selection'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { fromKeys, mapListFilter } from '@/lib/transformer'
import { discoveryParams } from '@/api/params'
import types from '@/lib/types'
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-resultpage-spbu',
  components: {
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-sort': DropdownSort,
    'adx-list-result': ExpandableResult,
    'infinite-loading': InfiniteLoading,
    'adx-modal': Modal,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-secondary': LoadingSecondary,
    'adx-collection-slider': CollectionSlider,
    'adx-input': Input,
    'adx-textarea': Textarea,
    'adx-empty-selection': EmptySelection,
  },
  props: {

  },
  data() {
    return {
      citiesId: {
        westJavaBanten: [],
        centralEastJava: [],
        sumatera: [],
        kalimantanSulawesi: [],
        jakarta: [],
      },
      citiesGrouping: null,
      count: null,
      createParams: {},
      customDescriptionInput: null,
      customNameInput: null,
      customPriceInput: null,
      endDate: null,
      items: [],
      isCreateCampaign: false,
      isCreateSaved: false,
      isLoading: false,
      isLoadingModal: false,
      isPageLoading: false,
      isShowOrderMobile: false,
      isShowCustomAds: false,
      isSubLoading: false,
      itemsCategory: ``,
      labelType: 'Sort',
      newTitle: '',
      next: null,
      page: 2,
      query: '',
      searchValue: ``,
      selectedCategory: `spbu`,
      selectedItems: [],
      selectedLocationDefault: [],
      selectedLocationValue: [],
      selectedLocationLabel: '',
      selectedPeriod: 1,
      selectedProfileValue: [],
      selectedSocialValue: [],
      selectedSortValue: `-traffic`,
      selectedSubQuickName: '',
      selectedTypeValue: '',
      selectedTypeName: '',
      showQuickFilter: false,
      startDate: null,
      status: ``,
      title: '',
      totalListing: 0,
      user: {
        admin : null
      },

      collectionOptions: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
        },
      ],
      dropdownOptions: [
        {
          label: '1 Month',
          value: 1
        },
        {
          label: '2 Months',
          value: 2
        },
        {
          label: '3 Months',
          value: 3
        },
        {
          label: '4 Months',
          value: 4
        },
        {
          label: '5 Months',
          value: 5
        },
        {
          label: '6 Months',
          value: 6
        },
        {
          label: '7 Months',
          value: 7
        },
        {
          label: '8 Months',
          value: 8
        },
        {
          label: '9 Months',
          value: 9
        },
        {
          label: '10 Months',
          value: 10
        },
        {
          label: '11 Months',
          value: 11
        },
        {
          label: '12 Months',
          value: 12
        }
      ],
      expansionList: [],
      locationOptions: [],
      socialOptions: [],
      sortOptions: [
        {
          id: 0,
          label: `Name`,
          value: `title`
        },
        {
          id: 1,
          label: `Traffic`,
          value: `-traffic`
        },
      ],
      profileOptions: [],

      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
    }
  },
  computed: {
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort' && key !== 'category' &&
        key !== 'property_type' && key !== 'query' && key !== 'city' &&
        querys[key]) filtered = true
      });

      return filtered
    },
    isPackage: function() {
      for (let item of this.selectedItems) {
        if (item.media_name == 'Experience Branding Package'){
          this.endDate = this.endDatePackage
          return true
          break
        }
      }
      false
    },
    endDatePackage: function(){
      var end = new Date(this.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + this.selectedPeriod);
      return end
    },
    getFilterParams: function () {
      const params = {
        query: this.searchValue ? this.searchValue : undefined,
        sort: this.selectedSortValue || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        city: this.selectedLocationValue.join(`,`) || '0',
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    ...mapGetters ({
      token: 'token',
      account: 'account'
    }),
    getCategoryCode: function() {
      return {...discoveryParams[this.selectedCategory]}
    },
    sumOrder: function() {
      return this.selectedItems.length
    },
    routeName: function() {
      return this.$route.params.city_name
    }
  },
  watch: {
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.checkLoad()
      });
    },
    searchValue: function() {
      this.$nextTick(() => {
        this.checkLoad()
      });
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.loadSavedandCampaign()
  },
  async mounted() {
    const query = this.$route.query
    this.user.admin = this.account.isStaff
    this.setCalenderValue()
    await this.getCitiesGrouping()
    await this.getFilter()

    // this.$nextTick(() => {
    //   console.log('mounted')
    //   this.loadCategory()
    // });
  },
  beforeUpdate() {

  },
  updated() {
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    customAdvertisement(list){
      this.toggleModalCustomAds()
    },
    toggleModalCustomAds(){
      this.isShowCustomAds = !this.isShowCustomAds
    },
    getTotal(){
      let total = 0
      this.selectedItems.forEach(element => {
        const item = element.include_tax? (element.price/1.1) : element.price
        total += item
      });
      return total
    },
    getTotalByPPN(){
      return this.getTotal() + (this.getTotal()*0.1)
    },
    continueButton(){
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: 'Success!',
        type: 'success'
      });
    },
    deleteOrder(index){
       this.selectedItems.splice( index, 1 );
    },
    loadSavedandCampaign() {
      while(this.expansionList.length > 0) {
        this.expansionList.pop()
      }
      this.expansionList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        const response = await api.get(apiV2.saved, { needToken: true })
        if (response.status === 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[0]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        }
      })();
    },
    loadCampaigns() {
      (async () => {
        const response = await api.get(apiV2.draftCampaigns, { needToken: true })
        if (response.status == 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[1]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        } else {
          // this.error = response.data.error
        }
      })();
    },
    createNewCampaign(params) {
      this.createParams = params
      this.isCreateCampaign = true
    },
    addToCampaign(list, item){
      let price = item.include_tax? (item.price/1.1) : item.price
      let media_name = item.media_name == `device`? `Digital Screen`: `Experience Branding Package`
      const ordered = this.selectedItems.map(x => {
        return x.item_id
      })
      let order = {
        location_id: list.id,
        item_id: item.id,
        title: list.title,
        price: price,
        media_name: media_name,
      }

      if (ordered.includes(item.id)){
        this.$notify({
          group: 'saved',
          title: 'Error',
          text:  'Item already in order',
          type: 'danger'
        });
      } else {
        this.selectedItems.push(order)
      }
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.loadSavedandCampaign()
        }
      })();
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    createNew(params) {
      this.createParams = params
      this.isCreateSaved = true
    },
    toggleModalCreate() {
      this.isCreateSaved = !this.isCreateSaved
    },
    toggleModalOrder() {
      this.isShowOrderMobile = !this.isShowOrderMobile
    },
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    checkLoad() {
      this.loadCategory()
    },
    resetSpecificFilter() {
      this.selectedProfileValue = []
      this.selectedSocialValue = []
      this.selectedLocationValue = []
      this.selectedLocationLabel = undefined
      this.getFilter()
    },
    loadCategory() {
      (async () => {
        this.itemsCategory = []
        this.isSubLoading = true
        const searchValue = this.searchValue
        let params = {
          ...this.getFilterParams,
          category: `spbu`
        }
        const { data , status} = await api.get(apiV2.spbuResult, { params })

        if (data) {
            this.itemsCategory = await data.results || []
            this.count = await data.count
            this.next = await data.next
            this.totalListing = await this.itemsCategory.length
        }
        this.page = 2
        this.$nextTick(()=>{
          this.isSubLoading = false
        })   
        this.status = status
        
      })();
    },
    async loadInfiniteData($state) {
      if (this.$data.next) {
        this.$data.isLoading = true
        let params = {
          page: this.$data.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.searchResult, { params })
        if (data.results) {
          this.$data.itemsCategory = this.$data.itemsCategory.concat(data.results)
          this.totalListing = this.$data.itemsCategory.length
          this.$data.count = data.count
          this.$data.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
        } else {
          // $state.complete()
        }
        this.$data.page += 1
        this.$data.isLoading = false
      }
    },
    getFilter () {
      this.isSubLoading = true;
      (async () => {
        let categoryCode = this.getCategoryCode? this.getCategoryCode.category : undefined
        const { data } = await api.get(apiV2.searchFilter, {
          params: { category: categoryCode }
        })
        this.mapFilter(data)
      })();
    },
    async getCitiesGrouping() {
      let file = `/static/data/cities_grouping.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let { cities_grouping } = await request.json();

        this.citiesGrouping = cities_grouping
      })();
    },
    loadCities(data) {
      let location = [] 
      Object.keys(this.citiesGrouping).map((key) => {
        let keyname = key.toLowerCase()
        if (keyname.includes(this.routeName.toLowerCase())){
          this.title = key
          this.citiesGrouping[key].forEach(city => {
            for (let obj of data) {
              let name = obj.title.toLowerCase()
              if (name.includes(city)) {
                location.push({id: obj.id, value: obj.id, label:obj.title})
                break;
              }
            }
          })
        }
      });
      if (!this.title.length && this.$route.params.city_name) this.title = this.$route.params.city_name
      return location
    },
    mapFilter (data) {
      const social = mapListFilter({ obj: data.social, id: `id`, value: `level`, label: `title`})
      const profile = mapListFilter({ obj: data.profile, id: `id`, value: `id`, label: `name`})
      this.socialOptions = social
      this.profileOptions = profile
      let location = []
      if (this.routeName) {
        location = this.loadCities(data.cities)
      } else {
        location =  mapListFilter({ obj: data.cities, id: `id`, value: `id`, label: `title`})
      }
      let citiesId = location.map(city => {
        return city.id
      })
      this.selectedLocationValue = citiesId
      this.selectedLocationDefault = citiesId
      this.locationOptions = location
    },
    selectedSocial(item){
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `-traffic`
      } else {
        this.selectedSortValue = item.value
      }
    },
    selectedProfile(item){
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedLocation(item){
      this.selectedLocationValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    setCalenderValue() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      this.startDate = nextweek
      var nextweekplus = new Date();
      nextweekplus.setDate(nextweekplus.getDate() + 8);
      this.endDate = nextweekplus
    },
    resetFilter() {
      this.selectedProfileValue = []
      this.selectedSocialValue = []
      this.selectedLocationValue = this.selectedLocationDefault
      this.selectedLocationLabel = ''
      this.selectedSortValue = '-traffic'

      const params = {
        profile: undefined,
        social: undefined,
        city: undefined
      }
    },
    gotoDetail(item, list) {
      const {pub_id, media_name} = item
      const {property_type} = list
      const category_display =  `spbu`
      let path = this.convertToUrl(property_type, media_name, category_display) + `${pub_id}`

      let route = this.$router.resolve({path: path});
      window.open(route.href, '_blank');
    },
    goToLocationDetail(list) {
      this.$router.push({name: 'detailspbuv2', params: { id: list.id}})
    },
    convertToUrl(property_type, media_name, category_display){
      return `/${this.mediaNameUrl(media_name)}/spbu/`
    },
    mediaNameUrl(media_name){
      if (media_name.toLowerCase().trim() == 'device'){
        return 'digital'
      } else {
        return 'experience'
      }
    },
    allCollection(){
      console.log('all collection')
    },
    saveCustomAdv(){
      this.isLoadingModal = true
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.resultPageSPBU {
  .cardSlider {
    margin-left: -8px;
  }
  .modal__content{
    &.mini {
      width: 30%;
    }
  }
  &__modalAds__input {
    .input, .textArea {
      label {
        top: 16px;
      }
    }
  }
}
.resultPageSPBU__bottom__content__orderSummary__content {
  .date-picker-input{
    font-size: 15px;
  }
  .selectDropdown .select input {
    font-size: 15px;
  }
}

@include breakpoint (md) {
.resultPageSPBU {
  &__bottom__content__orderSummary--mobile__content {
    .selectDropdown .popup {
      height: 350px;
      overflow: auto;
    }
  }
  .cardSlider {
    margin-left: -8px;
  }
  .modal__content {
    &__header {
      margin-bottom: 0px;
      width: unset;
      height: unset;

      button {
        width: unset;
        .icon-close {
          font-size: 24px;
          color: #999999
        }
      }
    }
  }
}
}
</style>
